export const DataStatut = Object.freeze({
  ACTIF: 'actif',              // Actif
  INACTIF: 'inactif',          // Inactif
  DELETED: 'deleted',          // Supprimé
  DRAFT: 'draft',              // Brouillon
});